import { axiosInstance as axios, handleAxiosErrors } from '../_utils';
import { buildElasticGraphQLParams } from '../selectors/converterSelector';
import config from '../store/_config';

export const axiosRequestUnpaidInvoices = (listParams) => {
    let { url, query } = config.invoice.unpaidListing;

    if (listParams.filters.Total__GTE) {
        listParams.filters['TotalDue__GTE'] = listParams.filters.Total__GTE;
        delete listParams.filters.Total__GTE;
    }
    if (listParams.filters.Total__LTE) {
        listParams.filters['TotalDue__LTE'] = listParams.filters.Total__LTE;
        delete listParams.filters.Total__LTE;
    }

    let params = buildElasticGraphQLParams(listParams);

    query = query.replace(/Filters:{}/, params);

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
};
export const axiosRequestPaidInvoices = (listParams) => {
    let { url, query } = config.invoice.paidListing;
    let params = buildElasticGraphQLParams(listParams);
    query = query.replace(/Filters:{}/, params);

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
};
export const axiosRequestReciprocalInvoices = (listParams) => {
    let { url, query } = config.invoice.reciprocalListing;
    let params = buildElasticGraphQLParams(listParams);

    query = query.replace(/Filters:{}/, params);

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
};
export const axiosPayInvoice = (payload) => {
    let { url, query } = config.invoice.pay;

    return axios.post(
        url,
        { id: query, variables: payload },
        {
            withCredentials: true,
        }
    );
};
export const axiosTotalOverdueInvoice = (payload) => {
    let { url } = config.invoice.overdue;

    return axios.get(url, {
        withCredentials: true,
    });
};
export const axiosRequestBankDetail = (InvoiceID) => {
    let { url, query } = config.creditCard.bankDetails;

    query = query.replace(/{InvoiceID}/, InvoiceID);

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
};

export const axiosUpdateInvoiceStatus = (ID, Status) => {
    let { url, query } = config.invoice.updateStatus;

    query = query.replace(/{ID}/, ID).replace(/{Status}/, Status);

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
};
